<template>
  <dash-board-layout :active="8" :fulid="true">
    <div class="verification section-padding">
      <div class="container h-100">
        <div class="row justify-content-center h-100 align-items-center">
          <div class="col-xl-6 col-md-6">
            <div class="auth-form card">
              <div class="card-header">
                <h4 class="card-title">Add Bank information</h4>
              </div>
              <div class="card-body">
                <form @submit.prevent="formSubmit" class="identity-upload">
                  <div class="form-row">
                    <!-- <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Card number </label>
                      <input
                        type="text"
                        disabled
                        class="form-control"
                        v-model="showCardNum"
                        placeholder=""
                      />
                    </div> -->

                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Name *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="showCardName"
                        placeholder="Satoshi Nakamoto"
                      />
                    </div>
                    <el-divider content-position="left"
                      >Bank Address Info</el-divider
                    >

                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Country *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="bankAddressDetails.country"
                        placeholder="US"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">City *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="bankAddressDetails.city"
                        placeholder="Boston"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Line1 *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="bankAddressDetails.line1"
                        placeholder="100 Money Street"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Line2</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="bankAddressDetails.line2"
                        placeholder="Suite 1"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">District</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="bankAddressDetails.district"
                        placeholder="MA"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Postal Code *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="bankAddressDetails.postalCode"
                        placeholder="910000"
                      />
                    </div>
                    <el-divider content-position="left"
                      >Billing Info</el-divider
                    >

                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">City *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="billingDetails.city"
                        placeholder="Boston"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Country *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="billingDetails.country"
                        placeholder="US"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Line1 *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="billingDetails.line1"
                        placeholder="100 Money Street"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Line2</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="billingDetails.line2"
                        placeholder="Suite 1"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">District</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="billingDetails.district"
                        placeholder="MA"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Postal Code *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="billingDetails.postalCode"
                        placeholder="910000"
                      />
                    </div>

                    <div class="text-center col-12">
                      <button type="submit" class="btn btn-success pl-5 pr-5">
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dash-board-layout>
</template>
<script>
import DashBoardLayout from "../../components/layouts/DashBoardLayout.vue";
import { att_bank_address_details } from "../../plugins/api/user_bank_acc";
export default {
  components: { DashBoardLayout },
  data() {
    return {
      showCardNum: "",
      showCardName:"",
      active: "addDebitCard",
      cardType: "no",
      isCreditCard: false,
      hasNumber: false,
      loading: false,
      bankAddressDetails: {
        name: "",
        city: "",
        country: "",
        line1: "",
        line2: "",
        district: "",
        postalCode: "",
      },
      billingDetails: {
        name: "",
        city: "",
        country: "",
        line1: "",
        line2: "",
        district: "",
        postalCode: "",
      },
    };
  },
  created() {
    // this
    this.showCardNum = this.$route.query.c;
    this.showCardName = this.$route.query.n;
  },
  methods: {
    formSubmit() {
      att_bank_address_details({
        token: this.$route.query.token,
        billingDetails: this.billingDetails,
        bankAddress: this.bankAddressDetails,
      }).then((res) => {
        if (res.code == 0) {
          this.$alert(
            "When the supplement is complete, the OTC919 verification review will be ready for use.",
            "Props",
            {
              confirmButtonText: "Enter",
              type: "success",
              showClose: false,
              closeOnClickModal: false,
              callback: (action) => {
                this.$router.push(`/settings-account`);
              },
            }
          );
        } else {
          this.$Message.error(res.msg);
        }
      });
      // this.$router.push("/verify-step-6");
    },
    editCardNum() {
      this.hasNumber = false;
    },
    openForm() {
      let that = this;
      if (this.baseInfo.cardNum.length >= 16) {
        let startVal = this.baseInfo.cardNum;
        if (startVal.length > 0) {
          startVal = startVal.substr(0, 1);
        }
        switch (parseInt(startVal)) {
          case 6:
            this.isCreditCard = false;
            this.hasNumber = true;
            this.cardType = "unionpay";
            break;
          case 3:
            this.cardType = "ae";
          case 4:
            this.cardType = "visa";
          case 5:
            this.cardType = "mastercard";
            this.isCreditCard = true;
            this.hasNumber = true;
            this.showCardNum = this.$cardop.fourNums(this.baseInfo.cardNum);
            break;
          default:
            this.cardType = "";
            this.hasNumber = false;
            this.isCreditCard = false;
            this.$Message.warning("Card number has error.");
            break;
        }

        // this.loading = true;
        // setTimeout(() => {
        //   that.loading = false;
        // }, 500);
      } else {
        this.$Message.warning("Card number has error.");
      }
    },
  },
};
</script>
